import { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import CampaignTypeSelector from "./CampaignTypeSelector";
// import { FaArrowUp } from "react-icons/fa";

const Container = styled(motion.div)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 12px;
  padding: 1rem;
  padding-bottom: calc(2rem + 20px);
  position: relative;

  /* Subtle beveled edge effect */
  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 0px;
    right: 0px;
    bottom: 2px;
    background: transparent;
    border-radius: 10px;
    box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.6),
      0 0 0 1px rgba(255, 255, 255, 0.1) inset,
      0 1px 1px rgba(0, 0, 0, 0.1) inset;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0.1rem;
    border-radius: 0;
  }
`;

const ArrowIndicator = styled(motion.div)`
  color: #0066ff;
  font-size: 2rem;
  margin-bottom: 1.5rem;
`;

const Message = styled.h3`
  font-size: 2rem; // 1.5rem
  // color: #2d3748;
  color: #333333;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 500;
`;

// const Subtitle = styled.p`
//   font-size: 1rem; // 1.1rem
//   color: #718096;
//   text-align: center;
//   max-width: 400px;
//   line-height: 1.6;
// `;

// const RocketGif = styled.div`
//   width: 100px;
//   height: 100px;
//   margin: 0 auto;
// `;

// Styled components:


const PlaceholderUI = ({ onSend, campaignId }) => {
  const lastCampaignIdRef = useRef(campaignId);

  // Update when campaign changes
  useEffect(() => {
    if (lastCampaignIdRef.current !== campaignId) {
      lastCampaignIdRef.current = campaignId;
    }
  }, [campaignId]);

  // Handle selection from the campaign type selector
  const handleCampaignSelection = (selection) => {
    if (selection.type === 'website' && selection.url) {
      // Format URL if needed
      const formattedUrl = /^https?:\/\//.test(selection.url) 
        ? selection.url 
        : "https://" + selection.url;
      onSend(formattedUrl);
    } else if (selection.type === 'list' && selection.prospects) {
      // Pass enriched prospects, job_to_be_done, websiteUrl, and scheduler_link to parent
      onSend('list_campaign', false, {
        prospects: selection.prospects,
        total: selection.total,
        job_to_be_done: selection.job_to_be_done,
        websiteUrl: selection.websiteUrl,  // Pass website URL for campaign
        scheduler_link: selection.scheduler_link,  // Pass scheduler_link from CSV upload
        calendly_link: selection.calendly_link  // Pass calendly_link from CSV upload
      });
    }
  };

  return (
    <Container
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <ArrowIndicator
        animate={{
          y: [-10, 0, -10],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        {/* <FaArrowUp /> */}
        {/* <RocketGif>
          <img
            src="/rocket.gif"
            alt="rocket"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </RocketGif> */}
      </ArrowIndicator>
      <Message>Ready to Start Your Campaign?</Message>
      <CampaignTypeSelector onDataSubmit={handleCampaignSelection} />
    </Container>
  );
};

export default PlaceholderUI;
